










import {Component, Vue} from 'vue-property-decorator';


@Component({})
export default class VelocityGroup extends Vue {
  enter(el: Element, complete: any): void {
    this.$emit("enter", {el, complete})
  }

  leave(el: Element, complete: any): void {
    this.$emit("leave", {el, complete})
  }
  
  afterLeave(): void {
    this.$emit("afterLeave")
  }
}
